/* @flow */

import { Roles } from 'permissions/defs';
import type { RoleList } from 'permissions/defs';
import type { Environment } from 'config';

/**
 * This is a whitelist item
 */
export type FeatureFlag = {
  enabled: boolean,
  /**
   * Which roles does this flag block apply to. For all roles, leave this field out.
   */
  restrictToRoles?: RoleList,
  /**
   * Which environments does this block concern. For all encironments, leave this field out.
   */
  envs?: Environment[],
};

const features: { [x: string]: FeatureFlag[] } = {
  reporting: [
    {
      enabled: true,
    },
  ],
  legalEntity: [
    {
      enabled: false,
    },
  ],
};

export default features;
